import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin( ScrollTrigger )

const REVEAL_DEFAULTS = {
	y: 28,
	duration: 1,
	ease: 'power3.out',
}

const initFadeUp = (el) => {
	const delay = parseFloat( el.dataset.animateDelay || '0', 10 )

	gsap.fromTo(
		el,
		{ autoAlpha: 0, y: REVEAL_DEFAULTS.y },
		{
			autoAlpha: 1,
			y: 0,
			duration: REVEAL_DEFAULTS.duration,
			ease: REVEAL_DEFAULTS.ease,
			delay: Number.isNaN( delay ) ? 0 : delay,
			scrollTrigger: {
				trigger: el,
				start: 'top 88%',
				once: true,
			},
		}
	)
}

const initStaggerSections = () => {
	document.querySelectorAll( '[data-animate-stagger]' ).forEach( (section) => {
		const selector = section.dataset.animateStagger

		if ( ! selector ) {
			return
		}

		const targets = section.querySelectorAll( selector )

		if ( ! targets.length ) {
			return
		}

		gsap.fromTo(
			targets,
			{ autoAlpha: 0, y: 24, scale: 1.02 },
			{
				autoAlpha: 1,
				y: 0,
				scale: 1,
				duration: 0.95,
				ease: 'power3.out',
				stagger: 0.1,
				scrollTrigger: {
					trigger: section,
					start: 'top 85%',
					once: true,
				},
			}
		)
	})
}

export const initImageReveals = () => {
	const images = document.querySelectorAll( '.media-block__image, .media-block__video' )

	if ( ! images.length ) {
		return
	}

	const targets = Array.from( images ).filter( (img) => ! img.closest( '[data-animate-stagger]' ) )

	if ( ! targets.length ) {
		return
	}

	ScrollTrigger.batch( targets, {
		start: 'top 92%',
		once: true,
		onEnter: (batch) => {
			gsap.fromTo(
				batch,
				{ autoAlpha: 0, scale: 1.05 },
				{
					autoAlpha: 1,
					scale: 1,
					duration: 1.1,
					ease: 'power3.out',
					stagger: 0.06,
					overwrite: true,
				}
			)
		},
	} )
}

export const initPageEnter = () => {
	const main = document.querySelector( '#main' )

	if ( ! main?.children.length ) {
		return
	}

	gsap.from( main.children, {
		autoAlpha: 0,
		y: 22,
		duration: 0.95,
		stagger: 0.06,
		ease: 'power3.out',
		delay: 0.08,
	} )
}

export const initReveals = () => {
	document.querySelectorAll( '[data-animate="fade-up"]' ).forEach( initFadeUp )
	initStaggerSections()
	initImageReveals()
}
